import { CompanyDetailedDto } from 'models/dtoTypes';

export const ENTITY_COLOR: { [key: string]: string } = {
  'business-planning': '#24c8a8',
  'contractual-planning': '#ff75a8',
  'financial-planning': '#ffa800',
  'regulatory-planning': '#96d4d0',
  'risk-management': '#85868a',
  'sustainability-goals': '#3544d0',
};

export function getScoreColor(scoreAlias?: string | null): string {
  return scoreAlias ? ENTITY_COLOR[scoreAlias] : '#000000';
}

export const getSustainabilityScore = (company?: CompanyDetailedDto) => {
  const { scores } = company || {};
  if (scores) {
    const sustainabilityScore = scores.find((s) => s.scoreName === 'Sustainability');
    if (sustainabilityScore) {
      return sustainabilityScore?.score || 0;
    }
  }
  return 0;
};
